import { get } from './request'

export let list = (success, failure) => get(
  `api/roles/list`, success, failure
)
